import { render } from "./LeagueRegistration.vue?vue&type=template&id=03b7a168&scoped=true&lang=pug"
import script from "./LeagueRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./LeagueRegistration.vue?vue&type=script&setup=true&lang=js"

import "./LeagueRegistration.vue?vue&type=style&index=0&id=03b7a168&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b7a168"]])

export default __exports__